"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTERPRISE_COMBEE = exports.MAGIKARP = exports.RILLABOOM = exports.BASCULIN = exports.WOOPER = exports.VIVILLON = exports.SILVALLY = exports.RATICATE = exports.RALTS = exports.PORYGON2 = exports.PIDGEY = exports.PERSIAN = exports.ONIX = exports.MIGHTYENA = exports.METAGROSS = exports.LATIOS = exports.KARTANA = exports.DODRIO = exports.DEDENNE = exports.AUDINO = exports.ARCEUS = void 0;
exports.ARCEUS = {
    SERVICE_NAME: 'operations_silvally',
    ERROR: 'error',
    OPERATIONS: {
        CREATE_REQUESTED: 'operations.create_requested',
        UPDATE_REQUESTED: 'operations.update_requested',
        CREATED: 'operations.created',
        UPDATED: 'operations.updated',
    },
    ACTIVITY_REQUEST: {
        COMPLETED: 'activity_request.completed',
    },
};
exports.AUDINO = {
    SERVICE_NAME: 'mediations_audino',
    OPERATION: {
        CREATED: 'operation.created',
        UPDATED: 'operation.updated',
        REMINDED: 'operation.reminded',
    },
};
exports.DEDENNE = {
    SERVICE_NAME: 'leanplum_dedenne',
    EVENT: {
        EVENT_TRACKED: 'events.event_tracked',
        EVENT_TRACKING_FAILED: 'events.event_tracking_failed',
    },
    SEND_GOOGLE_ANALYTICS_MESSAGE: 'send_google_analytics_message',
    SEND_CHAMELEON_MESSAGE: 'send_chameleon_message',
    SEND_LEANPLUM_MESSAGE: 'send_leanplum_message',
    SEND_LEANPLUM_MESSAGES: 'send_leanplum_messages',
    SEND_LEANPLUM_MESSAGE_NOW: 'send_leanplum_message_now',
    SEND_LEANPLUM_MESSAGES_NOW: 'send_leanplum_messages_now',
    DEAD_LETTER: 'dead_letter',
    SUCCESS: 'success',
};
exports.DODRIO = {
    SERVICE_NAME: 'security_hub_dodrio',
    VERIFICATIONS: {
        DOCUMENT_FACIAL_SUBMITTED: 'verifications.document_facial_submitted',
        DOCUMENT_FACIAL_VERIFIED: 'verifications.document_facial_verified',
        DOCUMENT_FACIAL_REJECTED: 'verifications.document_facial_rejected',
        DOCUMENT_FACIAL_FAILED: 'verifications.document_facial_failed',
        WATCHLIST_FAILED: 'verifications.watchlist_failed',
        TIER_ANY: {
            PHONE_VERIFIED: 'verifications.tier_any.phone_verified',
            REVIEWED_DOCUMENT: 'verifications.tier_any.reviewed_document',
            REVIEWED_FACIAL: 'verifications.tier_any.reviewed_facial',
        },
        TIER_ONE: {
            ENTERED_MANUAL_REVIEW: 'verifications.tier_one.entered_manual_review',
            FAILED: 'verifications.tier_one.failed',
            REJECTED: 'verifications.tier_one.rejected',
            SUBMITTED: 'verifications.tier_one.submitted',
            VERIFIED: 'verifications.tier_one.verified',
        },
        TIER_TWO: {
            ENTERED_MANUAL_REVIEW: 'verifications.tier_two.entered_manual_review',
            REJECTED: 'verifications.tier_two.enhanced_rejected',
            SUBMITTED: 'verifications.tier_two.enhanced_submitted',
            VERIFIED: 'verifications.tier_two.enhanced_verified',
            FAILED: 'verifications.tier_two.enhanced_failed',
        },
        RIS: {
            ACCEPTED: 'verifications.ris.accepted',
            REJECTED: 'verifications.ris.rejected',
            MANUAL_REVIEW: 'verifications.ris.manual_review',
        },
        REPORTS: {
            FACIAL_CHECK: 'verifications.reports.facial_check',
        },
    },
    USER_MIGRATIONS: {
        TIER_ZERO: {
            COMPLETED: 'user_migrations.tier_zero.completed',
        },
    },
    USER: {
        UPDATED: 'user.updated',
        DEVICE_VERIFICATION_REQUESTED: 'user.device_verification_requested',
        SECONDARY_EMAIL_VERIFICATION_REQUESTED: 'user.secondary_email_verification_requested',
        USERNAME_UPDATED: 'user.username_updated',
        ELLIPTIC_LIMITED: 'user.elliptic_limited',
    },
    PERSONA: {
        USER_REGISTERED: 'persona.user_registered',
        INQUIRY_UPDATED: 'persona.inquiry_updated',
        REPORT_UPDATED: 'persona.report_updated',
    },
    VASP: {
        RISK_LEVEL_TRIGGERED: 'vasp.risk_level_triggered',
    },
};
exports.KARTANA = {
    SERVICE_NAME: 'virtual_cards_kartana',
    ERROR: 'error',
};
exports.LATIOS = {
    SERVICE_NAME: 'matching_latios',
    ERROR: 'error',
    OPERATIONS: {
        AVAILABLE_LISTED: 'operations.available_listed',
    },
};
exports.METAGROSS = {
    SERVICE_NAME: 'numbers_metagross',
    PERMISSIONS: {
        ACCEPT_ENABLED: 'permissions.accept_enabled',
    },
    USER: {
        SCORE_REQUESTED: 'user.score_requested',
        UPDATED: 'user.updated',
    },
    PAYMENT_METHODS: {
        CSV_UPLOAD_COMPLETED: 'payment_methods.csv_upload_completed',
        CSV_UPLOAD_FAILED: 'payment_methods.csv_upload_failed',
    },
};
exports.MIGHTYENA = {
    SERVICE_NAME: 'backoffice_mightyena',
    PAYMENT_METHODS: {
        CSV_UPLOADED: 'payment_methods.csv_uploaded',
    },
};
exports.ONIX = {
    SERVICE_NAME: 'oauth2_onix',
    SIGNUP: {
        ENTERPRISE_SIGNUP_REACHED: 'signup.enterprise_signup_reached',
        SIGN_UP_CONFIRMED: 'signup.signup_confirmed',
        SIGN_UP_PARTIAL_COMPLETED: 'signup.partial_completed',
        SIGN_UP_COMPLETED: 'signup.signup_completed',
        SIGN_UP_REACHED: 'signup.signup_reached',
        SIGN_UP_REACHED_TWICE: 'signup.signup_reached_twice',
    },
    MFA: {
        LOGIN_TRIGGERED: 'mfa_login_triggered',
        LOGIN_AUTHENTICATED: 'mfa_login_authenticated',
    },
    RESET_PASSWORD: {
        EMAIL_SENT: 'reset_password_email_sent',
        RESET: 'reset_password_reset',
    },
    TERMS: {
        ACCEPTED: 'terms.accepted',
        DECLINED: 'terms.declined',
    },
    USERS: {
        LOGGED_IN: 'users.logged_in',
        STATUS_UPDATED: 'users.status_updated',
        DATA_UPDATED: 'users.data_updated',
        ROLE_GRANTED: 'users.role_granted',
        ROLE_DELETED: 'users.role_deleted',
    },
    MFA_RECOVERY: {
        REQUESTED: 'mfa_recovery_requested',
        CONFIRMED: 'mfa_recovery_confirmed',
    },
};
exports.PERSIAN = {
    SERVICE_NAME: 'air_ledger_persian',
    TRANSACTIONS: {
        ERROR: 'error',
        COLLECT_MOVEMENT_REQUESTED: 'transactions.collect_movement_requested',
        DISBURSE_CREATED: 'transactions.disburse_created',
        DISBURSE_REQUESTED: 'transactions.disburse_requested',
        DISPERSE_MOVEMENT_REQUESTED: 'transactions.disperse_movement_requested',
        GENERIC_TRANSACTION_REQUESTED: 'transactions.generic_transaction_requested',
        HOLDING_CREATED: 'transactions.holding_created',
        HOLDING_REQUESTED: 'transactions.holding_requested',
        MULTI_MOVEMENT_REQUESTED: 'transactions.multi_movement_requested',
        PROFIT_MOVEMENT_REQUESTED: 'transactions.profit_movement_requested',
        RESERVE_DEPOSIT_CREATED: 'transactions.reserve_deposit_created',
        RESERVE_DEPOSIT_REQUESTED: 'transactions.reserve_deposit_requested',
        RESERVE_MOVEMENT_CREATED: 'transactions.reserve_movement_created',
        RESERVE_MOVEMENT_REQUESTED: 'transactions.reserve_movement_requested',
        RESERVE_TRADE_CREATED: 'transactions.reserve_trade_created',
        RESERVE_TRADE_REQUESTED: 'transactions.reserve_trade_requested',
        RESERVE_WITHDRAW_CREATED: 'transactions.reserve_withdraw_created',
        RESERVE_WITHDRAW_REQUESTED: 'transactions.reserve_withdraw_requested',
        SIMPLE_MOVEMENT_CREATED: 'transactions.simple_movement_created',
        SIMPLE_MOVEMENT_REQUESTED: 'transactions.simple_movement_requested',
    },
};
exports.PIDGEY = {
    SERVICE_NAME: 'chat_pidgey',
    MESSAGES: {
        MESSAGE_SENT: 'messages.sent',
        MESSAGE_READ: 'messages.read',
    },
};
exports.PORYGON2 = {
    SERVICE_NAME: 'wyre_porygon2',
    COMMAND: {
        UPDATE_ACCOUNT: 'command.update_account',
        UPDATE_PAYMENT_METHOD: 'command.update_payment_method',
    },
    EVENT: {
        ACCOUNT_PENDING: 'events.account_pending',
        ACCOUNT_VERIFIED: 'events.account_verified',
        ACCOUNT_REJECTED: 'events.account_rejected',
        PAYMENT_METHOD_ACTIVATED: 'events.payment_method_activated',
        PAYMENT_METHOD_ACTIVATION_FAILED: 'events.payment_method_activation_failed',
        PAYMENT_METHOD_REJECTED: 'events.payment_method_rejected',
        PAYMENT_METHOD_REJECTION_FAILED: 'events.payment_method_rejection_failed',
    },
    SUCCESS: 'success',
};
exports.RALTS = {
    SERVICE_NAME: 'preferences_ralts',
    MFA: {
        LOGIN_ENABLED: 'mfa.login_enabled',
        LOGIN_DISABLED: 'mfa.login_disabled',
        OPERATIONS_ENABLED: 'mfa.operations_enabled',
        OPERATIONS_DISABLED: 'mfa.operations_disabled',
    },
    PROFILE: {
        LANGUAGE_UPDATED: 'profile.language_updated',
    },
    TAGS: {
        UPDATED: 'tags.updated',
    },
};
exports.RATICATE = {
    SERVICE_NAME: 'referrals_raticate',
    INVITATIONS: {
        SENT: 'invitations.sent',
        UPDATE_REQUESTED: 'invitations.update_requested',
    },
    SETTINGS: {
        UPDATED: 'settings.updated',
    },
};
exports.SILVALLY = {
    SERVICE_NAME: 'operations_silvally',
    ERROR: 'error',
    OPERATIONS: {
        CREATE_REQUESTED: 'operations.create_requested',
        UPDATE_REQUESTED: 'operations.update_requested',
        CREATED: 'operations.created',
        UPDATED: 'operations.updated',
    },
};
exports.VIVILLON = {
    SERVICE_NAME: 'payment_methods_vivillon',
    PAYMENT_METHODS: {
        RULE_UPDATED: 'payment_methods.rule_updated',
    },
    INSTANCES: {
        INSTANCE_CREATED: 'instances.instance_created',
        INSTANCE_UPDATED: 'instances.instance_updated',
    },
};
exports.WOOPER = {
    SERVICE_NAME: 'airmxn_wooper',
    OPERATIONS: {
        EVENTS: 'operations.events',
    },
};
exports.BASCULIN = {
    SERVICE_NAME: 'aggregators_basculin',
    USERS: {
        FIRST_LOGIN_AFTER_SIGNUP: 'users.first_user_login',
    },
    OPERATIONS: {
        FIRST_ADD_FUNDS: 'operations.first_add_funds',
        FIRST_WITHDRAW_FUNDS: 'operations.first_withdraw_funds',
    },
};
exports.RILLABOOM = {
    SERVICE_NAME: 'saasquatch_rillaboom',
    REWARDS: {
        CREATED: 'rewards.created',
    },
    DEAD_LETTER: 'dead_letter',
    SUCCESS: 'success',
};
exports.MAGIKARP = {
    SERVICE_NAME: 'webhooks_magikarp',
    DEAD_LETTER: 'dead_letter',
    SUCCESS: 'success',
};
exports.ENTERPRISE_COMBEE = {
    SERVICE_NAME: 'enterprise_combee',
    BULK_PAYOUT: {
        COMPLETED: 'bulk_payout.completed',
    },
    PAYOUT: {
        CANCELLATION_COMPLETED: 'payout.cancellation_completed',
    },
    STATEMENT: {
        COMPLETED: 'statement.completed',
    },
};
